import { StyleRulesCallback, Table as SuperTable, withStyles } from '@material-ui/core';
import { TableProps } from '@material-ui/core/Table';
import _get from 'lodash/get';
import _omit from 'lodash/omit';
import React from 'react';

const styles: StyleRulesCallback = theme => ({
  wrapper: {
    overflowX: 'scroll',
  },
});

const Table = (props: TableProps & { classes: { [key: string]: string } }) => (
  <div className={_get(props.classes, 'wrapper')}>
    <SuperTable {..._omit(props, 'classes.wrapper')} />
  </div>
);

export default withStyles(styles)(Table);



// WEBPACK FOOTER //
// ./src/components/Table/Table.tsx